package app.bloomey.web.components.modals

import androidx.compose.runtime.*
import app.bloomey.web.core.offCanvas.LocalOffCanvasController
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.*

@Composable
fun OffCanvasHost() {
    val offCanvasController = LocalOffCanvasController.current
    val items = offCanvasController.items

    if (items.isNotEmpty())
        Box(
            modifier = Modifier.fillMaxSize()
                .maxHeight(100.vh)
                .backgroundColor(
                    ColorMode.current.toSitePalette().background
                        .toRgb().copy(alpha = 50)
                )
                .zIndex(3)
        )
    val scope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()
    items.forEachIndexed { index, item ->
        var offset by remember { mutableStateOf(100) }
        LaunchedEffect(index) {
            scope.launch {
                delay(300)
                offset = 10
            }
        }
        Box(
            contentAlignment = Alignment.BottomEnd,
            modifier = Modifier.fillMaxSize()
                .zIndex(3)
        ) {
            Box(modifier = Modifier.fillMaxSize()
                .onClick {
                    offCanvasController.pop(item)
                })
            item.Content(
                Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
                    .maxWidth(500.px)
                    .position(Position.Fixed)
                    .overflowWrap(OverflowWrap.Anywhere)
                    .boxShadow(
                        (-4).px,
                        color = sitePalette.onBackground.lightened(.93f),
                        blurRadius = 16.px,
                        spreadRadius = (-2).px
                    )
                    .translateX(-(offset * (items.lastIndex - index)).percent)
                    .transition(CSSTransition(TransitionProperty.All, duration = 300.ms))
            )
        }
    }
}